export default __webpack_public_path__ + "static/media/benefit-3@2x.ae41ebf8.png";